import { createSelector } from 'reselect';
import { isPresent } from 'utils/isPresent';

import { getEntities } from '../../../Resources/EntityData';

type IsEntityPresentSelectorProps = {
  namespace: string;
  key: string;
}

export const isEntityPresentSelector = createSelector(
  getEntities,
  (_state: unknown, props: IsEntityPresentSelectorProps) => props,
  (entities, props) => {
    const { namespace, key } = props;
    return isPresent(entities) && isPresent(entities[namespace]) && isPresent(entities[namespace][key]);
  },
);
